import { useEffect, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Preciso%20de%20um%20or%C3%A7amento.';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
          <a href="/">
            <img
              src="https://static.readdy.ai/image/b82e091d2ee2b446e9b53ab9857e20be/1bea56054998f72dc157944f3d260472.png"
              alt="Vidros Thelux Logo"
              className="h-10 md:h-14 object-contain"
            />
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`hidden md:flex items-center gap-2 px-5 py-2 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-200 cursor-pointer ${scrolled ? 'bg-green-500 text-white hover:bg-green-600' : 'bg-white/20 text-white border border-white/50 hover:bg-white/30'}`}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            Falar no WhatsApp
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-full bg-green-500 text-white cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
          </a>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=luxury%20modern%20apartment%20balcony%20with%20articulated%20frameless%20glass%20enclosure%20sliding%20panels%20open%20view%20city%20skyline%20S%C3%A3o%20Paulo%20high%20end%20architecture%20natural%20light%20premium%20finish&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Envidraçamento de sacada de alto padrão"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/65 to-black/30"></div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16">
          <div className="max-w-2xl">
            <span className="inline-block text-xs font-semibold tracking-widest text-white/70 uppercase mb-4 border border-white/30 px-3 py-1 rounded-full">
              Envidraçamento de Sacada — São Paulo
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-4 drop-shadow-lg">
              Vidros Thelux: A Excelência em Envidraçamento de Sacadas de Alto Padrão em São Paulo.
            </h1>
            <p className="text-xs md:text-sm text-white/85 mb-3 font-light">
              A melhor solução em Envidraçamento e Fechamento de Sacadas Articuladas com acabamento premium.
            </p>
            <p className="text-sm text-white/75 mb-8 font-light leading-relaxed">
              Não arrisque o seu investimento com instalações genéricas. Fale agora com um de nossos consultores técnicos e receba um orçamento personalizado para o seu projeto.
            </p>

            <div className="inline-flex items-center gap-3 bg-amber-500/15 border border-amber-400/30 rounded-full px-5 py-2.5 mb-8">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-scales-3-line text-amber-400 text-sm"></i>
              </div>
              <p className="text-amber-200 font-semibold text-sm">
                Nosso orçamento não é o mais barato, é o justo.
              </p>
            </div>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-8 py-4 rounded-full text-base md:text-lg transition-all duration-200 whitespace-nowrap hover:scale-105 cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl"></i>
              </div>
              FALAR COM CONSULTOR
            </a>
            <div className="flex flex-wrap gap-4 mt-8">
              {['Vidro Temperado Premium', 'Sem Roldanas', 'Instalação Garantida', 'NBR 7199'].map((tag) => (
                <span key={tag} className="flex items-center gap-1.5 text-white/80 text-xs font-medium">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-green-400 text-sm"></i>
                  </div>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/50 animate-bounce">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-line text-lg"></i>
          </div>
        </div>
      </section>
    </>
  );
}
